/**
 * UserModeContext - DEPRECATED shim (Sprint 1, F1.1)
 * ==================================================
 *
 * The original `UserModeContext` (Business ↔ Accountant) and the unused
 * `AccountingModeContext` (Standard ↔ Accounting) were consolidated into a
 * single `DisplayModeContext`. This file is kept as a thin shim so any
 * pre-existing imports (eg. `TaxGovernancePage`) keep working until they
 * are migrated.
 *
 * New code MUST import `useDisplayMode` from `./DisplayModeContext`.
 */
import React from 'react';
import {
  DisplayModeProvider,
  useDisplayMode,
} from './DisplayModeContext';
import { DISPLAY_MODES, LABELS } from './displayLabels';

// Preserve the legacy `USER_MODES` enum surface.
export const USER_MODES = {
  BUSINESS: DISPLAY_MODES.BUSINESS,
  ACCOUNTANT: DISPLAY_MODES.ACCOUNTANT,
};

// Preserve the legacy label map for any module that still imports it
// directly. The canonical labels are now plain strings - we still expose
// the same {key: string} surface so consumers keep working.
export const BUSINESS_MODE_LABELS = { ...LABELS };

export const ACCOUNTANT_ONLY_ITEMS = [];
export const ACCOUNTANT_ONLY_REPORTS = [];

// Re-export the provider under its old name so any double-mount in App.js
// is harmless (DisplayModeProvider treats remount as the same context tree
// when nested - see implementation).
export const UserModeProvider = ({ children }) => children;

export const useUserMode = () => {
  const ctx = useDisplayMode();
  return {
    userMode: ctx.mode,
    setUserMode: ctx.setMode,
    toggleMode: ctx.toggleMode,
    isBusinessMode: ctx.isBusinessMode,
    isAccountantMode: ctx.isAccountantMode,
    getLabel: ctx.getLabel,
    isItemVisible: (label) => {
      if (ctx.isAccountantMode) return true;
      return !ACCOUNTANT_ONLY_ITEMS.includes(label);
    },
    isReportVisible: (reportName) => {
      if (ctx.isAccountantMode) return true;
      return !ACCOUNTANT_ONLY_REPORTS.includes(reportName);
    },
    syncing: false,
    USER_MODES,
  };
};

const _UserModeContext = React.createContext(null);
export default _UserModeContext;
